module.exports = __webpack_public_path__ + "static/media/memory_1.40ec14d5.png";